import { useQuery } from '@tanstack/react-query';
import * as dashboardService from '../services/dashboardService';
import { DASHBOARD_KEY } from '../utils/query-keys';

export const useDashboardStats = () =>
  useQuery({
    queryKey: [...DASHBOARD_KEY, 'stats'],
    queryFn: dashboardService.getDashboardStats,
  });

export const useDashboardAiMatchAnalytics = (eventId?: string | null) =>
  useQuery({
    // Multi-event: eventId in the key so switching the event filter refetches
    // (and All-events vs per-event values never serve each other's cache).
    queryKey: [...DASHBOARD_KEY, 'aiMatchAnalytics', eventId ?? 'all'],
    queryFn: () => dashboardService.getDashboardAiMatchAnalytics(eventId),
  });

export const useDashboardRecentActivity = () =>
  useQuery({
    queryKey: [...DASHBOARD_KEY, 'recentActivity'],
    queryFn: dashboardService.getDashboardRecentActivity,
  });

export const useDashboardInsights = () =>
  useQuery({
    queryKey: [...DASHBOARD_KEY, 'insights'],
    queryFn: dashboardService.getDashboardInsights,
  });
